"use client";

import { Field as FieldPrimitive } from "@base-ui/react/field";
import { mergeProps } from "@base-ui/react/merge-props";
import * as React from "react";
import { cn } from "@/lib/utils";

export type TextareaProps = React.ComponentPropsWithoutRef<"textarea"> & {
  size?: "sm" | "default" | "lg" | number;
  unstyled?: boolean;
};

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { className, size = "default", unstyled = false, ...props },
  ref,
): React.ReactElement {
  return (
    <span
      className={
        cn(
          !unstyled &&
            "relative inline-flex w-full rounded-[var(--paper-radius-control)] border border-control-border bg-control-default text-sm text-foreground transition-[border-color,box-shadow,background-color] hover:border-control-border-hover hover:bg-control-highlight has-focus-visible:border-ring has-focus-visible:bg-control-default has-focus-visible:ring-2 has-focus-visible:ring-ring/15 has-focus-visible:has-aria-invalid:border-destructive has-focus-visible:has-aria-invalid:ring-destructive/15 has-aria-invalid:border-destructive has-aria-invalid:ring-2 has-aria-invalid:ring-destructive/15 has-disabled:bg-muted/60 has-disabled:opacity-60 data-[size=sm]:rounded-md",
          className,
        ) || undefined
      }
      data-size={size}
      data-slot="textarea-control"
    >
      <FieldPrimitive.Control
        ref={ref}
        value={props.value}
        defaultValue={props.defaultValue}
        disabled={props.disabled}
        id={props.id}
        name={props.name}
        render={(defaultProps: React.ComponentProps<"textarea">) => (
          <textarea
            className={cn(
              "field-sizing-content min-h-20 w-full rounded-[inherit] px-3 py-2 outline-none focus:outline-none focus-visible:outline-none active:outline-none",
              size === "sm" && "min-h-16 px-2.5 py-1.5",
              size === "lg" && "min-h-24 py-2.5",
            )}
            data-slot="textarea"
            {...mergeProps(defaultProps, props)}
          />
        )}
      />
    </span>
  );
});

export { FieldPrimitive };
